module.exports = __webpack_public_path__ + "fe6a0c79961917e0b7883fb5052a7264.png";